<script>
import { v3ServiceApi } from "@/services/v3/v3.service";
import SettingsPermission from "@/permission/settings.permission";
import { XButton } from "@/components/ui-components/button";
import BaseLoading from "@/components/Reusable/BaseLoading.vue";
import { XIcon } from "@/components/ui-components/material-icons";
import { XCircularBackground } from "@/components/ui-components/circular-background";
import SettingsCreateRegion from "@/views/settings/components/SettingsCreateRegion.vue";

import BaseArrowLeftIcon from "@/components/icons/BaseArrowLeftIcon";
import BaseArrowRightIcon from "@/components/icons/BaseArrowRightIcon";

export default {
  name: "SettingsLocations",
  components: {
    BaseArrowLeftIcon,
    BaseArrowRightIcon,

    BaseLoading,
    XButton,
    XIcon,
    XCircularBackground,
    SettingsCreateRegion,
  },
  data() {
    return {
      currentLang: "",
      upsertType: "create",
      showCreateModal: false,
      showEditTagModal: false,
      editStorage: {},
      editTags: {},
      table: {
        items: [],
        loading: false,
      },
      permission: {
        view: SettingsPermission.getPermission("locations.view"),
        create: SettingsPermission.getPermission("locations.create"),
        edit: SettingsPermission.getPermission("locations.edit"),
        delete: SettingsPermission.getPermission("locations.delete"),
      },
    };
  },
  computed: {
    query() {
      return this.$route.query;
    },
    tableFields() {
      const fields = [
        {
          key: "id",
          label: this.$t("id"),
        },
        {
          key: "name",
          label: this.$t("title"),
          formatter: (v) => v[this.$i18n.locale],
        },
        {
          key: "districts",
          label: this.$t("districts"),
        },
        // {
        //   key: "tags",
        //   label: "tags",
        //   thStyle: "width: 200px",
        // },
      ];
      if (this.permission.edit) {
        fields.push({
          key: "actions",
          label: "",
          thStyle: "width: 100px",
        });
      }
      return fields;
    },
  },
  watch: {
    query() {
      this.fetchItems();
    },
  },
  created() {
    this.fetchItems();
  },
  methods: {
    editRegionDistricts(region) {
      this.$router.push({
        name: "location-districts",
        params: {
          id: region.id,
        },
      });
    },
    changeFetchLimit() {
      const query = {
        ...this.query,
        page: this.query.page || 1,
      };
      const limit = this.showByValue;
      this.$router.replace({ query: { ...query, limit } });
    },

    changeCurrentPage(page) {
      const currentPage = this.query.page;
      if (page === currentPage) return;
      this.$router.replace({ query: { ...this.query, page } });
    },
    setTab(e) {
      this.currentLang = e;
    },
    startLoading() {
      this.table.loading = true;
    },
    finishLoading() {
      this.table.loading = false;
    },
    createVersion() {
      this.setUpsertType("create");
      this.openVersionCreationModal();
    },
    async fetchItems() {
      try {
        this.startLoading();
        const response = await v3ServiceApi.regions.index();
        console.log(response.data);
        this.table.items = response.data.result.map((el) => ({
          ...el,
        }));
      } catch (e) {
        this.toastedWithErrorCode(e);
      } finally {
        this.finishLoading();
      }
    },
    setUpsertType(eType) {
      if (["create", "edit"].includes(eType)) {
        this.upsertType = eType;
      }
    },
    openVersionCreationModal() {
      this.showCreateModal = true;
    },
    closeVersionCreationModal() {
      this.showCreateModal = false;
    },

    translationCreated() {
      this.closeVersionCreationModal();
      this.fetchItems();
    },

    async deleteItem(typeId) {
      this.$swal({
        title: this.$t("sweetAlert.title"),
        text: this.$t("sweetAlert.text"),
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: this.$t("cancel"),
        confirmButtonText: this.$t("sweetAlert.yes"),
      }).then(async (result) => {
        if (result.value) {
          try {
            this.startLoading();
            await v3ServiceApi.regions.remove({ id: typeId });
            await this.fetchItems();
          } catch (e) {
            this.toastedWithErrorCode(e);
          } finally {
            this.finishLoading();
          }
        }
      });
    },

    async editVersion(item) {
      try {
        this.editStorage = item;
        this.setUpsertType("edit");
        this.openVersionCreationModal();
      } catch (e) {
        this.toastedWithErrorCode(e);
      }
    },
  },
};
</script>

<template>
  <div v-if="permission.view" class="app-settings-client-type">
    <!-- TODO: CLIENT TYPES TABLE   -->
    <div class="d-flex mb-4 justify-content-between">
      <h3
        class="x-font-size-1p5 font-craftworksans color-gray-400 d-flex align-items-center"
      >
        {{ $t("regions") }}
      </h3>

      <x-button
        v-if="permission.create"
        variant="secondary"
        :text="$t('addRegion')"
        :bilingual="true"
        @click="createVersion"
      >
        <template #left-icon>
          <x-icon name="add" class="violet-600" />
        </template>
      </x-button>
    </div>

    <b-table
      id="my-table"
      ref="apartment-list-table"
      thead-tr-class="row__head__bottom-border"
      tbody-tr-class="row__body__bottom-border"
      class="table__list mt-5"
      sticky-header
      borderless
      show-empty
      responsive
      sort-icon-left
      :items="table.items"
      :fields="tableFields"
      :busy="table.loading"
      :empty-text="$t('no_data')"
    >
      <template #table-busy>
        <base-loading />
      </template>

      <template #empty="scope">
        <span class="d-flex justify-content-center align-items-center">
          {{ scope["emptyText"] }}
        </span>
      </template>

      <template #cell(districts)="{ item }">
        <div class="d-flex x-gap-1 cursor-pointer align-items-center">
          <span>{{ item.districts?.length || 0 }} </span>
          <div :style="item.loading ? 'opacity: 0.5' : ''" title="save">
            <x-circular-background
              v-if="permission.edit"
              class="bg-sea-green-600"
              @click="editRegionDistricts(item)"
            >
              <x-icon name="edit" class="color-white" />
            </x-circular-background>
          </div>
        </div>
      </template>

      <template #cell(actions)="{ item }">
        <div class="float-right d-flex x-gap-1 cursor-pointer">
          <div :style="item.loading ? 'opacity: 0.5' : ''" title="save">
            <x-circular-background
              v-if="permission.delete"
              class="bg-red-600"
              @click="deleteItem(item.id)"
            >
              <x-icon name="delete" class="color-white" />
            </x-circular-background>
          </div>
          <div :style="item.loading ? 'opacity: 0.5' : ''" title="save">
            <x-circular-background
              v-if="permission.edit"
              class="bg-sea-green-600"
              @click="editVersion(item)"
            >
              <x-icon name="edit" class="color-white" />
            </x-circular-background>
          </div>
        </div>
      </template>
    </b-table>

    <settings-create-region
      v-if="showCreateModal"
      :upsert-type="upsertType"
      :edit-item="editStorage"
      @close-creating-modal="closeVersionCreationModal"
      @client-type-created="translationCreated"
    />
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/scss/utils/pagination";

@import "@/assets/scss/utils/b-table-redesign.scss";
@import "@/views/settings/assets/crudTable.scss";
.translation-tag {
  padding: 6px 12px;
  &:not(:last-child) {
    margin-right: 5px;
  }
}
.row-opacity {
  opacity: 0.2;
}
.tag:not(:first-child) {
  margin-top: 10px;
}
</style>
